import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoLike = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	fill: "#3844bc",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M145.5 65.076C86.613 73.116 45.037 125.552 48.43 187.5c4.267 77.9 46.093 145.283 128.07 206.328C191.635 405.099 254.281 447 255.996 447c1.699 0 64.281-41.865 79.504-53.186C419.875 331.069 463.34 258.733 463.374 181c.016-34.782-10.493-61.364-33.254-84.117-45.75-45.735-116.38-43.1-165.334 6.168l-8.713 8.77-10.287-10.16C217.76 73.977 180.325 60.321 145.5 65.076m.16 20.972C103.275 93.161 71.554 129.711 69.328 174c-3.323 66.085 34.162 134.872 104.244 191.293C190.477 378.903 253.149 422 256.036 422c4.201 0 74.055-49.19 93.464-65.816 62.137-53.227 96.536-120.674 93.171-182.684-3.56-65.611-67.337-105.761-127.928-80.537-16.162 6.729-32.338 20.163-49.243 40.897-4.95 6.071-9.225 11.038-9.5 11.038-.275 0-3.65-3.898-7.5-8.662-20.104-24.877-36.395-37.958-56.336-45.235-14.557-5.313-32.791-7.255-46.504-4.953",
		fillRule: "evenodd"
	})
});
export default SvgIcoLike;
